import { FormEvent, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

export default function EditTemplateTitle({
  title,
  setTitleValue,
}: {
  title: string;
  setTitleValue: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [isEditable, setIsEditable] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditable) {
      inputRef.current?.focus();
    }
  }, [isEditable]);

  const handleDoubleClick = () => {
    setIsEditable(true);
  };

  const handleBlur = () => {
    (
      document.getElementById("submit-flow-template-btn") as HTMLButtonElement
    ).click();
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formdata = new FormData(e.currentTarget);
    const title = formdata.get("title")?.toString().trim();

    if (!title) {
      toast.warning("Title can not be empty!");
      return;
    }

    setTitleValue(title);
    setIsEditable(false);
    // await updateTableTitle({ title, id });
  };

  return isEditable ? (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        name="title"
        className="px-[10px] py-1 text-[0.9rem] text-[#333] rounded-md transition-colors duration-300 focus:border-[#d0d5dd] focus:outline-none focus:ring-2 focus:ring-[rgba(21,93,233,0.2)] placeholder:text-[#344054]"
        ref={inputRef}
        defaultValue={title}
        onBlur={handleBlur}
        required
        minLength={2}
      />
      <input type="submit" className="hidden" id="submit-flow-template-btn" />
    </form>
  ) : (
    <h2
      className="text-lg font-semibold cursor-pointer"
      onDoubleClick={handleDoubleClick}
    >
      {title}
    </h2>
  );
}
